import { Box, Typography } from '@mui/material'
import React from 'react'

function PrivacyPolicy() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
  <h1>Privacy Policy</h1>
  <p><strong>Last updated:</strong> April 10, 2026</p>

  <p>
    This Privacy Policy explains how <strong>Papere</strong> ("App") collects, uses, stores, shares, and protects your information.
    Papere is developed and operated by <strong>I T WAVES (PRIVATE) LIMITED</strong>,
    No 183, Sunanda Mawatha, Walgama, Matara, Southern Province, Sri Lanka.
  </p>

  <h2>1. Who We Are</h2>
  <p>
    <strong>Developer / Legal Entity:</strong> I T WAVES (PRIVATE) LIMITED<br />
    <strong>App Name:</strong> Papere<br />
    <strong>Address:</strong> No 183, Sunanda Mawatha, Walgama, Matara, Southern Province, Sri Lanka<br />
    <strong>Email:</strong> mgmskumara@gmail.com<br />
    <strong>Phone:</strong> +94 71 384 8468
  </p>

  <h2>2. Scope of This Policy</h2>
  <p>
    This Privacy Policy applies to your use of Papere on Android, iOS, and related services.
    By using the App, you agree to the collection and use of information as described in this Privacy Policy.
  </p>

  <h2>3. Information We Collect</h2>

  <h3>3.1 Information You Provide Directly</h3>
  <p>Depending on how you use the App, we may collect information you provide directly, such as:</p>
  <ul>
    <li>Name</li>
    <li>Email address</li>
    <li>Phone number</li>
    <li>Profile details</li>
    <li>Educational preferences or app-related content you submit</li>
    <li>Messages or support inquiries you send to us</li>
  </ul>

  <h3>3.2 Information Collected Automatically</h3>
  <p>When you use the App, we may automatically collect certain technical and usage information, including:</p>
  <ul>
    <li>Device model</li>
    <li>Operating system and version</li>
    <li>App version</li>
    <li>IP address</li>
    <li>Language and region</li>
    <li>App usage data, interactions, screens viewed, session activity, and diagnostic information</li>
    <li>Crash logs and performance data</li>
    <li>Advertising identifiers or similar device identifiers, where permitted</li>
  </ul>

  <h3>3.3 Information Collected Through Permissions</h3>
  <p>
    Depending on the features you use and the permissions you grant, the App may access:
  </p>
  <ul>
    <li><strong>Camera</strong> – to capture images or content within the App</li>
    <li><strong>Photos / Media / Storage</strong> – to select, upload, download, or store files and images</li>
    <li><strong>Notifications</strong> – to send updates, reminders, and important service messages</li>
  </ul>
  <p>
    You can control permissions through your device settings. If you deny certain permissions, some features may not function properly.
  </p>

  <h2>4. How We Use Your Information</h2>
  <p>We may use your information to:</p>
  <ul>
    <li>Provide, operate, and maintain Papere</li>
    <li>Create and manage your account</li>
    <li>Deliver educational content and app features</li>
    <li>Respond to support requests and communicate with you</li>
    <li>Send service-related notifications and updates</li>
    <li>Improve app performance, reliability, and user experience</li>
    <li>Monitor usage trends and analyze engagement</li>
    <li>Detect, prevent, and address technical issues, abuse, fraud, or security incidents</li>
    <li>Display ads, where applicable</li>
    <li>Comply with legal obligations</li>
  </ul>

  <h2>5. Third-Party Services We Use</h2>
  <p>
    Papere may use third-party tools and service providers to support app functionality, analytics, crash reporting, notifications, hosting, and advertising.
    These providers may collect, process, and store data in accordance with their own privacy policies and applicable laws.
  </p>

  <h3>5.1 Firebase and Google Services</h3>
  <p>The App may use Google Firebase and related Google services, including:</p>
  <ul>
    <li><strong>Firebase Analytics</strong> – to understand app usage and improve features</li>
    <li><strong>Firebase Crashlytics</strong> – to monitor crashes and improve stability</li>
    <li><strong>Firebase Cloud Messaging</strong> – to send push notifications</li>
    <li><strong>Firebase Authentication</strong> – if used for login or account management</li>
  </ul>

  <h3>5.2 Advertising Services</h3>
  <p>
    The App may display advertisements using advertising partners such as <strong>Google AdMob</strong> or similar services.
    These partners may use device identifiers, advertising IDs, approximate location, usage data, and similar information to provide and measure ads, subject to your device settings, consent choices, and applicable law.
  </p>

  <h3>5.3 Other Service Providers</h3>
  <p>We may also use third-party providers for services such as:</p>
  <ul>
    <li>Cloud hosting and storage</li>
    <li>Customer support</li>
    <li>Content delivery</li>
    <li>Security and fraud prevention</li>
    <li>Performance monitoring</li>
  </ul>

  <h2>6. Data Sharing</h2>
  <p>We do not sell your personal information. We may share information only in the following situations:</p>
  <ul>
    <li>With service providers who process data on our behalf to operate the App</li>
    <li>With analytics, crash reporting, push notification, and advertising partners as described above</li>
    <li>When required by law, regulation, legal process, or governmental request</li>
    <li>To protect our rights, users, systems, or services</li>
    <li>In connection with a merger, acquisition, restructuring, or sale of assets</li>
    <li>With your consent or at your direction</li>
  </ul>

  <h2>7. Advertising, Tracking, and Consent</h2>
  <p>
    If the App uses personalized advertising or tracking technologies, we will seek consent where required by applicable law.
    On iOS, if tracking is used as defined by Apple, permission may be requested through Apple’s App Tracking Transparency framework.
    You can also manage certain advertising and privacy preferences through your device settings.
  </p>

  <h2>8. Children’s Privacy</h2>
  <p>
    Papere may be used by students. We do not knowingly collect personal information from children in violation of applicable law.
    If you are a parent or guardian and believe that a child has provided personal information without appropriate authorization, please contact us.
    We will review the request and take appropriate action.
  </p>

  <h2>9. Data Retention</h2>
  <p>
    We retain personal information only for as long as reasonably necessary for the purposes described in this Privacy Policy,
    including providing the App, complying with legal obligations, resolving disputes, enforcing agreements, and maintaining security.
  </p>
  <p>
    Retention periods may vary depending on the type of data, how the App is used, and applicable legal requirements.
    Some technical, analytics, and backup data may remain for a limited period before deletion or anonymization.
  </p>

  <h2>10. Data Security</h2>
  <p>
    We take reasonable technical and organizational measures to protect your information against unauthorized access, loss, misuse, or alteration.
    However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.
  </p>

  <h2>11. Your Rights and Choices</h2>
  <p>Depending on your location and applicable law, you may have rights to:</p>
  <ul>
    <li>Access the personal data we hold about you</li>
    <li>Request correction of inaccurate or incomplete data</li>
    <li>Request deletion of your account or personal data</li>
    <li>Object to or restrict certain processing</li>
    <li>Withdraw consent where processing is based on consent</li>
    <li>Manage device permissions and notification preferences</li>
  </ul>

  <h2>12. Account Deletion</h2>
  <p>
    If you have created an account in Papere, you may request deletion of your account and associated personal data.
    Where available, account deletion can be initiated from within the App. You may also contact us at
    <strong>mgmskumara@gmail.com</strong> to request account deletion.
  </p>
  <p>
    Please note that we may retain certain information where necessary for legal, security, fraud-prevention, accounting, or legitimate business purposes.
  </p>

  <h2>13. International Data Transfers</h2>
  <p>
    Your information may be processed and stored in countries other than your own, including where our service providers operate.
    Where such transfers occur, we take reasonable steps to ensure appropriate safeguards are in place as required by applicable law.
  </p>

  <h2>14. Links to Third-Party Services</h2>
  <p>
    The App may contain links to third-party websites or services. We are not responsible for the privacy practices, content, or policies of those third parties.
    We encourage you to review their privacy policies before providing information.
  </p>

  <h2>15. Changes to This Privacy Policy</h2>
  <p>
    We may update this Privacy Policy from time to time. If we make material changes, we may notify you through the App or by other appropriate means.
    The updated version will be posted with a revised “Last updated” date.
  </p>

  <h2>16. Contact Us</h2>
  <p>If you have any questions, concerns, or requests regarding this Privacy Policy, you may contact:</p>
  <p>
    <strong>I T WAVES (PRIVATE) LIMITED</strong><br />
    No 183, Sunanda Mawatha, Walgama, Matara, Southern Province, Sri Lanka<br />
    Email: mgmskumara@gmail.com<br />
    Phone: +94 71 384 8468
  </p>
</div>

  )
}

export default PrivacyPolicy